export const msalConfig = {
    auth: {
        clientId: 'f534c251-e474-4245-b2a2-42e6d09c1985',
        authority: 'https://login.microsoftonline.com/ea397a62-143c-468e-b042-d70e2c8dc618',
        redirectUri: window.location.protocol + '//' + window.location.host,
        prompt: 'admin_consent'
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: [
        'api://f534c251-e474-4245-b2a2-42e6d09c1985/Access',
    ]
};